import { init } from './MallCPAZXYears';
init();
